import { APPLICATION } from './application';

export const COMPONENTS = { APPLICATION };
